import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { provideTranslocoScope } from '@ngneat/transloco';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Store } from '@ngxs/store';
import { FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS, SessionState } from '@platform-frontend/account';
import { TranslationId, TypedChanges } from '@platform-frontend/util';
import { filter, Observable, tap } from 'rxjs';
import { ACCOUNT_UI_TRANSLOCO_SCOPE } from '../account-ui-transloco-scope';

@UntilDestroy()
@Component({
  selector: 'yat-registration-complete-text',
  templateUrl: './registration-complete-text.component.html',
  styleUrls: ['./registration-complete-text.component.scss'],
  providers: [provideTranslocoScope(ACCOUNT_UI_TRANSLOCO_SCOPE)]
})
export class RegistrationCompleteTextComponent implements OnInit, OnChanges {
  constructor(private store: Store) {}

  @Input()
  isTrial: boolean = false;

  @Input()
  registrationCompleteText?: TranslationId | null;

  email$: Observable<string | null> = this.store.select(SessionState.email);
  textTranslationId: TranslationId | null = null;

  ngOnInit(): void {
    FALLBACK_ACCOUNT_CUSTOMIZED_TEXTS('pureSignIn')
      .registrationComplete.text(this.store)
      .pipe(
        filter(() => !this.registrationCompleteText),
        tap(translationId => (this.textTranslationId = translationId)),
        untilDestroyed(this)
      )
      .subscribe();
  }

  ngOnChanges(changes: TypedChanges<RegistrationCompleteTextComponent>): void {
    if (changes.registrationCompleteText && this.registrationCompleteText) {
      this.textTranslationId = this.registrationCompleteText;
    }
  }
}
